// client/src/api/associationApi.js
import axios from 'axios';

// Register a new association and user
const registerAssociation = async (formData, config) => {
  try {
    const formDataObj = {};
    for (let [key, value] of formData.entries()) {
      formDataObj[key] = value;
    }

    // Don't set Content-Type manually — axios sets it automatically for
    // FormData with the correct multipart boundary.
    const response = await axios.post(`/api/associations`, formData, {
      ...config,
      validateStatus: function (status) {
        return status < 500;
      }
    });

    if (response.data && response.data.token) {
      localStorage.setItem('token', response.data.token);
    }

    return response.data;
  } catch (error) {
    console.error('Registration error details:', {
      message: error.message,
      response: error.response?.data,
      status: error.response?.status,
      statusText: error.response?.statusText,
      headers: error.response?.headers,
      config: error.config
    });

    throw error.response?.data || { message: error.message };
  }
};

// Get association profile
const getAssociationProfile = async (associationId) => {
  try {
    const response = await axios.get(`/api/association/${associationId}`);
    
    if (response.data.success) {
      return response.data.data;
    }
    return response.data;
  } catch (error) {
    console.error('Error fetching association profile:', error);
    throw error.response?.data || error.message;
  }
};

// Update association profile
const updateAssociationProfile = async (associationId, formData) => {
  try {
    // Don't set Content-Type manually — axios sets it automatically for
    // FormData with the correct multipart boundary.
    const response = await axios.put(`/api/association/${associationId}`, formData);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export default {
  registerAssociation,
  getAssociationProfile,
  updateAssociationProfile
};
